import { React, useState, Fragment, useEffect, createContext } from 'react';
import { useForm, Controller } from 'react-hook-form';
// import { ThemeProvider, StyledEngineProvider, makeStyles } from '@mui/styles';
import Card from '@mui/material/Card';
import CardContent from '@mui/material/CardContent';
import TopActions from '../actions/TopActions';
import Toast from '../actions/Toasts';
import Grid from '@mui/material/Grid';
import Typography from '@mui/material/Typography';
import FormControlLabel from '@mui/material/FormControlLabel';
import apiService from '../../services/apiServices';
import InputController from '../../controllers/InputController';
import SelectController from '../../controllers/SelectController';
import dateFormats from '../../services/dateFormats';
import {
  BrowserRouter as Router,
  // Switch,
  Route,
  Link,
  useParams,
} from 'react-router-dom';
import { Bars } from 'react-loader-spinner';
import { TextareaAutosize, Switch } from '@mui/material';
import { jsPDF } from "jspdf";

export default function EditWorkerContract() {
  const ContextProvider = createContext().Provider

  //const classes = useStyles();
  const alert = { open: false, message: '', variant: '' };
  const [toast, setToast] = useState(alert);
  const [worker, setWorker] = useState([]);
  const [workTypes, setWorkTypes] = useState([]);
  const [departments, setDepartments] = useState([]);
  const [branch, setBranch] = useState([]);
  const [contracts, setContracts] = useState([]);
  const [contractDetails, setContractDetails] = useState([]);
  const [settings, setSettings] = useState()
  const {
    register,
    handleSubmit,
    setValue,
    control,
    watch,
    formState: { errors },
  } = useForm();
  const salaryTypes = [{ id: 0, name: "" }, { id: 1, name: "Mujore" }, { id: 2, name: "Me ore" }]
  const contractExtension = [{ id: 0, name: "" }, { id: 1, name: "Mujore" }, { id: 2, name: "Vjetore" }]
  const brutoNeto = [{ id: 0, name: "" }, { id: 1, name: "Bruto" }, { id: 2, name: "Neto" }]
  let { id, con } = useParams();
  const [loader, setLoader] = useState(true);
  const [contractTemplate, setContractTemplate] = useState()
  const [templates, setTemplates] = useState([])
  const workerTags = ["FirstName", "LastName", "ParentName", "PersonalId", "Address", "Phone", "PostalCode", "BankAccount", "BankName", "Birthday", "Country", "Place", "Email", "Gender", "MaritalStatus", "Qualification", "ContractType", "StartDate", "EndDate", "WorkType", "SalaryType", "Department", "BaseSalary", "BrutoNeto", "HourSalary", "HourSalaryWeekend", "HourSalaryHoliday", "Image", "TermsOfContract"]

  useEffect(() => {
    getTemplates()
    getContract()
    getSettings()
    //getContractTemplate()
    //getContractTemplate(data?.Template)
  }, []);

  useEffect(() => {
    console.log(contractDetails)
    getContractTemplate(contractDetails?.Template)
    setValue(
      'Template', templates?.find(function (e) {
        return e.id === contractDetails.Template;
      })
    );
  }, [contractDetails, templates])

  const getContract = () => {
    apiService()
      .query('getContract', 'id=' + id)
      .then((wc) => {
        if (wc.success) {
          //setContracts(wc.data)
          console.log('wccc', wc)
          getWorker(wc.data[0].WorkerId)
          wc.data[0].Birthday = dateFormats(wc.data[0].Birthday);
          wc.data[0].StartDate = dateFormats(wc.data[0].StartDate);
          wc.data[0].EndDate = dateFormats(wc.data[0].EndDate);

          const fields = Object.keys(wc.data[0]);
          fields.map((field) => {
            if (field === 'SalaryType') {
              setValue(
                'SalaryType', salaryTypes.find(function (e) {
                  return e.id === wc.data[0].SalaryType;
                })
              );
            }
            else if (field === 'ContractType') {
              setValue(
                'ContractType', contractExtension.find(function (e) {
                  return e.id === wc.data[0].SalaryType;
                })
              );
            }
            else if (field === 'Template') {
              setValue(
                'Template', templates?.find(function (e) {
                  return e.id === wc.data[0].Template;
                })
              );
            }
            else if (field === 'BrutoNeto') {
              setValue(
                'BrutoNeto', brutoNeto?.find(function (e) {
                  return e.id === wc.data[0].BrutoNeto;
                })
              );
            }
            else if (field === 'EmployeeTax') {
              !wc.data[0][field] ? setValue(field, 0) : setValue(field, wc.data[0][field])
              wc.data[0][field] ? setValue('WithTax', true) : setValue('WithTax', false)
            }
            else if (field === 'EmployerTax') {
              !wc.data[0][field] ? setValue(field, 0) : setValue(field, wc.data[0][field])
              wc.data[0][field] ? setValue('WithTax', true) : setValue('WithTax', false)
            }
            else if (field === 'DestroyDate') {
              !wc.data[0][field] ? setValue(field, null) : setValue(field, dateFormats(wc.data[0][field]))
              wc.data[0][field] ? setValue('DestroyContract', true) : setValue('DestroyContract', false)
            }
            else if (field === 'DestroyReason') {
              !wc.data[0][field] ? setValue(field, null) : setValue(field, wc.data[0][field])
              wc.data[0][field] ? setValue('DestroyContract', true) : setValue('DestroyContract', false)
            }
            else {
              setValue(field, wc.data[0][field])
            }
          }
          );
          setContractDetails(wc.data[0]);

          apiService()
            .get('worktype')
            .then((wt) => {
              if (wt.success) {
                setWorkTypes(wt.data);
                setValue(
                  'WorkType', wt.data.find(function (e) {
                    return e.id === wc.data[0].WorkType;
                  })
                );
              } else {
                console.error('Error:' + wt.errorMessage);
              }
            });

          apiService()
            .query('getWorkerContracts', 'id=' + id)
            .then((wc) => {
              if (wc.success) {
                setContracts(wc.data)
              } else {
                console.error('Error:' + wc.errorMessage);
              }
            });

          apiService()
            .get('department')
            .then((dep) => {
              if (dep.success) {
                setDepartments(dep.data);
                setValue(
                  'Department',
                  dep.data.find(function (e) {
                    return e.id === wc.data[0].Department;
                  })
                );
              } else {
                console.error('Error:' + dep.errorMessage);
              }
            });
          apiService()
            .get('branch')
            .then((br) => {
              if (br.success) {
                setBranch(br.data);
                setValue(
                  'BranchId',
                  br.data.find(function (e) {
                    return e.id === wc.data[0].BranchId;
                  })
                );
              } else {
                console.error('Error:' + br.errorMessage);
              }
            });
          setLoader(false)
        } else {
          console.error('Error:' + wc.errorMessage);
        }
      });
  }
  const getWorker = (id) => {
    apiService()
      .query('getWorker', 'id=' + id)
      .then((wc) => {
        if (wc.success) {
          setWorker(wc.data[0])
        } else {
          console.log('Error:' + wc.errorMessage);
        }
      });
  }

  const toLowerKeys = (obj) => {
    return Object.keys(obj).reduce((accumulator, key) => {
      key = accumulator[key.charAt(0).toLowerCase() + key.slice(1, -1) + key.slice(-1).toLocaleLowerCase()] = obj[key];
      return accumulator;
    }, {});
  }

  const getTemplates = () => {
    apiService().get('contractsTemplates')
      .then(response => {
        if (response.success) {
          let arr = []
          let data = response.data
          data?.forEach(d => {
            //let obj = new ModelPurchaseDetails(d)
            arr.push(toLowerKeys(d))
          })
          setTemplates(arr)
        }
      })
  }

  const getContractTemplate = (id = templates[templates.length - 1]?.id) => {
    apiService().query('getTemplate', 'id=' + id)
      .then(response => {
        if (response.success) {
          let template = response.data[0]
          setContractTemplate(response.data[0])
        }
      })
  }

  const getSettings = () => {
    apiService().get("settings").then(response => {
        if(response.success) {
          setSettings(response.data[0])
        }
    })
}

  // const onSubmit = (data) => {
  //   console.log(data)
  // }

  const onSubmit = (data) => {
    console.log(data)
    data.ContractType = data.ContractType.id;
    data.WorkType = data.WorkType.id;
    data.SalaryType = data.SalaryType.id;
    data.Department = data.Department.id;
    data.BranchId = data.BranchId.id;
    data.BrutoNeto = data.BrutoNeto.id;
    data.Template = data.Template.id
    data.CreatedBy = "";
    console.log(data, id);
    apiService()
      .put('workerContract', data)
      .then((response) => {
        console.log(response)
        if (response.success) {
          setToast({
            open: true,
            message: 'U ruajten me sukses!',
            variant: 'success',
          });
          getContract()
        } else {
          setToast({
            open: true,
            message: 'Ka ndodhur nje gabim!',
            variant: 'error',
          });
        }
      });
  };

  const replaceText = (type) => {
    let text = contractTemplate?.Text;
    let data = Object.assign(worker, contractDetails)

    //console.log(data)

    workerTags?.forEach((tag, key) => {

      if (tag === 'Image') {
        console.log(tag, imageTag(data[tag.toString()]))
        text = text.replaceAll("@" + tag, data[tag.toString()] ? <img src={data[tag.toString()]} /> : "--");
      }
      else {
        text = text.replaceAll("@" + tag, data[tag.toString()] ? data[tag.toString()] : "--");
      }

    })
    //console.log(text)
    text = text.replaceAll('<!-- pagebreak -->', '<br style="page-break-before: always">')
    return text;
  }

  const imageTag = (src) => {
    return <img src={src} />
  }

  const toPdf = (fileName) => {
    setLoader(true)
    var doc = new jsPDF('p', 'pt', 'letter');
    //var elementHTML = replaceText('pdf');//document.querySelector("#contnet");

    var elementHTML = '<table >' +
      '<thead>' +
      '<tr class="">' +
      '<th>Name</th>' +
      "<th>Email</th>" +
      '<th>Phone</th>' +
      '</tr>' +
      '</thead>' +
      '<tbody>' +
      '<tr>' +
      '<td>Arsim</td>' +
      '<td>arsim@arsim.com</td>' +
      '<td>123456</td>' +
      '</tr>' +
      '</tbody>' +
      '</table>'

    console.log(elementHTML)
    doc.html(elementHTML, {
      callback: function (doc) {
        doc.save(fileName ? fileName + '.pdf' : 'document.pdf');
        setLoader(false)
      },
      autoPaging: 'text',
      margin: [12, 8, 15, 8],
      // html2canvas: {
      //   scale: 0.2
      // },
      // x: 15,
      // y: 15,
      // width: 170, //target width in the PDF document
      // windowWidth: 750 //window width in CSS pixels
    });

    // var doc = new jsPDF();

    // doc.text(20, 20, 'Hello world!');
    // doc.text(20, 30, 'This is client-side Javascript to generate a PDF.');

    // // Add new page
    // doc.addPage();
    // doc.text(20, 20, 'Visit CodexWorld.com');

    // // Save the PDF
    // doc.save('document.pdf');
  }

  const wordDoc = (element, filename = '') => {
    var invoiceBg = settings?.InvoiceBg;
    var header = "<html xmlns:o='urn:schemas-microsoft-com:office:office' xmlns:w='urn:schemas-microsoft-com:office:word' xmlns='http://www.w3.org/TR/REC-html40'><head><meta charset='utf-8'><title>Export HTML to Word Document with JavaScript</title></head><body style='background: url("+invoiceBg+")'>";
    var footer = "</body></html>";

    var html = header + replaceText() + footer;
    var blob = new Blob(['\ufeff', html], {
      type: 'application/msword'
    });
    var url = 'data:application/vnd.ms-word;charset=utf-8,' + encodeURIComponent(html);
    filename = filename ? filename + '.doc' : 'document.docx';
    var downloadLink = document.createElement("a");
    document.body.appendChild(downloadLink);

    if (navigator.msSaveOrOpenBlob) {
      navigator.msSaveOrOpenBlob(blob, filename);
    }
    else {
      downloadLink.href = url;
      downloadLink.download = filename;
      downloadLink.click();
    }

    document.body.removeChild(downloadLink);
  }

  const uploadContract = () => {
    var fileupload = document.getElementById("FileUpload1");
    fileupload.click();
  }

  const setTaxes = (isTrue, property) => {
    setValue(property, isTrue);
    if (property === "WithTax") {
      if (!isTrue) {
        setValue('EmployeeTax', 0);
        setValue('EmployerTax', 0);
      }
      else {
        !watch('EmployeeTax') ? setValue('EmployeeTax', 5) : setValue('EmployeeTax', watch('EmployeeTax'));
        !watch('EmployerTax') ? setValue('EmployerTax', 5) : setValue('EmployerTax', watch('EmployerTax'));
      }
    }
    else if (property === "DestroyContract") {
      if (!isTrue) {
        setValue('DestroyDate', null);
        setValue('DestroyReason', null);
      }
      else {
        !watch('DestroyDate') ? setValue('DestroyDate', dateFormats(new Date())) : setValue('DestroyDate', watch('DestroyDate'));
        !watch('DestroyReason') ? setValue('DestroyReason', " ") : setValue('DestroyReason', watch('DestroyReason'));
      }
    }
  }

  return (
    <div className="">
      <Fragment>
        <Toast {...toast} />
        <TopActions
          newHref="/workerlist/addworker"
          save={handleSubmit(onSubmit)}
          downloadContract={() => wordDoc('toWordDoc', worker?.FirstName + "_" + worker?.LastName)}
        //downloadContract={() => toPdf(worker?.FirstName + "_" + worker?.LastName)}
        />
        <input type="file" id="FileUpload1" style={{ display: 'none' }} />
        <div id="toWordDoc" style={{ display: 'none' }}>
          <p>Emri: {worker?.FirstName + " " + worker?.LastName}</p>
          <p>Kohezgjatja: {watch('StartDate') + " - " + watch('EndDate')}</p>
          <p>Paga bazë: {contractDetails?.BaseSalary}</p>
          <p>Paga për orë: {contractDetails?.HourSalary}</p>
        </div>

        <Card >
          <CardContent>
            <Typography variant="h6" gutterBottom>
              Contract Details
            </Typography>
            <form>
              {loader && <div className="loader-class"><Bars
                height="70"
                width="100%"
                color="#1976d2"
                ariaLabel="bars-loading"
                wrapperStyle={{}}
                wrapperClass=""
                visible={true}
              /></div>}
              {!loader && <>
                <Grid container spacing={3}>

                  <Grid item xs={12} sm={3} lg={3}>
                    <InputController
                      placeholder="Data e fillimit"
                      error={errors.StartDate}
                      control={control}
                      type="date"
                      register={{ ...register('StartDate') }}
                    />
                  </Grid>
                  <Grid item xs={12} sm={3} lg={3}>
                    <InputController
                      placeholder="Data e mbarimit"
                      error={errors.EndDate}
                      control={control}
                      type="date"
                      register={{ ...register('EndDate') }}
                    />
                  </Grid>

                  <Grid item xs={12} sm={3} lg={3}>
                    <SelectController
                      placeholder="Lloji i punes"
                      error={errors.WorkType}
                      control={control}
                      options={workTypes}
                      name="WorkType"
                      register={{ ...register('WorkType') }}
                    />
                  </Grid>
                  <Grid item xs={12} sm={3} lg={3}>
                    <SelectController
                      placeholder="Filiali"
                      error={errors.BranchId}
                      control={control}
                      options={branch}
                      name="BranchId"
                      register={{ ...register('BranchId') }}
                    />
                  </Grid>
                  <Grid item xs={12} sm={3} lg={3}>
                    <SelectController
                      placeholder="Departamenti"
                      error={errors.Department}
                      control={control}
                      options={departments}
                      name="Department"
                      register={{ ...register('Department') }}
                    />
                  </Grid>
                  <Grid item xs={12} sm={3} lg={3}>
                    <SelectController
                      placeholder="Tipi i pages"
                      error={errors.SalaryType}
                      control={control}
                      options={salaryTypes}
                      name="SalaryType"
                      register={{ ...register('SalaryType') }}
                    />
                  </Grid>
                  <Grid item xs={12} sm={3} lg={3}>
                    <InputController
                      placeholder="Paga bazë"
                      error={errors.BaseSalary}
                      control={control}
                      symbol="€"
                      register={{ ...register('BaseSalary') }}
                    />
                  </Grid>
                  <Grid item xs={12} sm={3} lg={3}>
                    <SelectController
                      placeholder="Bruto/Neto"
                      error={errors.BrutoNeto}
                      control={control}
                      options={brutoNeto}
                      name="BrutoNeto"
                      register={{ ...register('BrutoNeto') }}
                    />
                  </Grid>
                  <Grid item xs={12} sm={3} lg={3}>
                    <InputController
                      placeholder="Paga per orë"
                      error={errors.HourSalary}
                      control={control}
                      symbol="€"
                      register={{ ...register('HourSalary') }}
                    />
                  </Grid>
                  <Grid item xs={12} sm={3} lg={3}>
                    <InputController
                      placeholder="Paga per orë ditë vikendi"
                      error={errors.HourSalaryWeekend}
                      control={control}
                      symbol="€"
                      register={{ ...register('HourSalaryWeekend') }}
                    />
                  </Grid>
                  <Grid item xs={12} sm={3} lg={3}>
                    <InputController
                      placeholder="Paga per orë ditë feste"
                      error={errors.HourSalaryHoliday}
                      control={control}
                      symbol="€"
                      register={{ ...register('HourSalaryHoliday') }}
                    />
                  </Grid>
                  <Grid item xs={12} sm={3} lg={3}>
                    <SelectController
                      placeholder="Vazhdimi i kontratës"
                      error={errors.ContractExtension}
                      control={control}
                      options={contractExtension}
                      name="ContractType"
                      register={{ ...register('ContractType') }}
                    />
                  </Grid>
                  <Grid item xs={12} sm={3} lg={3}>
                    <SelectController
                      placeholder="Shablloni i kontratës"
                      error={errors.Template}
                      control={control}
                      options={templates}
                      name="Template"
                      register={{ ...register('Template') }}
                    />
                  </Grid>
                  <Grid item xs={12} sm={1} lg={1}>
                    <FormControlLabel
                      control={<Switch
                        error={errors.WithTax}
                        control={control}
                        name="WithTax"
                        register={{ ...register('WithTax') }}
                        onChange={(e) => setTaxes(e.target.checked, "WithTax")}
                        checked={watch("WithTax")}
                      />}
                      label="Kontributi"
                    />
                  </Grid>
                  {watch('WithTax') ?
                    <>
                      <Grid item xs={12} sm={2} lg={2}>
                        <InputController
                          placeholder="Kontributi i punëtorit"
                          error={errors.EmployeeTax}
                          control={control}
                          symbol="%"
                          value={watch('EmployeeTax') || 5}
                          register={{ ...register('EmployeeTax') }}
                          type="number"
                        />
                      </Grid>
                      <Grid item xs={12} sm={3} lg={3}>
                        <InputController
                          placeholder="Kontributi i punëdhënësit"
                          error={errors.EmployerTax}
                          control={control}
                          symbol="%"
                          value={watch('EmployerTax') || 5}
                          register={{ ...register('EmployerTax') }}
                          type="number"
                        />
                      </Grid>
                    </>
                    : ''}
                  <Grid item xs={12} sm={1} lg={1}>
                    <FormControlLabel
                      control={<Switch
                        error={errors.DestroyContract}
                        control={control}
                        name="DestroyContract"
                        register={{ ...register('DestroyContract') }}
                        onChange={(e) => setTaxes(e.target.checked, "DestroyContract")}
                        checked={watch("DestroyContract")}
                      />}
                      label="Ndërprej kontratën"
                    />
                  </Grid>
                  {watch('DestroyContract') ?
                    <>
                      <Grid item xs={12} sm={2} lg={2}>
                        <InputController
                          placeholder="Data e ndërprerjes"
                          error={errors.DestroyDate}
                          control={control}
                          type="date"
                          register={{ ...register('DestroyDate') }}
                        />
                      </Grid>
                      <Grid item xs={12} sm={6} lg={6}>
                        <InputController
                          placeholder="Arsyeja e ndërprerjes"
                          error={errors.DestroyReason}
                          control={control}
                          value={watch('DestroyReason')}
                          register={{ ...register('DestroyReason') }}
                          type="text"
                        />
                      </Grid>
                    </>
                    : ''}
                </Grid>
                <Grid item spacing={4} style={{ marginTop: 20 }}>
                  <TextareaAutosize
                    className='custom-textarea'
                    placeholder="Kushtet e kontratës"
                    error={errors.TermsOfContract}
                    control={control}
                    type="textarea"
                    register={{ ...register('TermsOfContract') }}
                    // cols="100"
                    style={{ width: '100%' }}
                    minRows={5}
                    name="TermsOfContract"
                    value={watch('TermsOfContract')}
                    onChange={(e) => setValue('TermsOfContract', e.target.value)}
                  />
                </Grid>

              </>}
            </form>

            {/* <ContextProvider>
                <Document>
                    <Text>Hello</Text>
                </Document>
            </ContextProvider> */}

          </CardContent>
        </Card>

      </Fragment>
    </div>
  );
}
